import { action } from 'mobx';
import { uniqBy } from 'lodash';
import ip from 'app/forms/validations/ip';
import { filterStateIpFilter } from 'app/util/cloud';
import PagedCollection from 'core/model/PagedCollection';

const VIEW_DROPDOWN_DISCREET_FILTER_NAME = 'view-subscription-dropdown';

class SubscriptionFilterCollection extends PagedCollection {
  isValidIP(value) {
    return ip.fn(value);
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  @action
  filter(query = undefined, options = {}) {
    if (query !== undefined) {
      this.resetDiscreteFilters();
      super.filter(query, options);
      this.applyPagination();
    }

    if (query === undefined) {
      super.filter(query, options);
    }

    if (this.filterState && this.isValidIP(this.filterState)) {
      const { mostSpecificMatches } = filterStateIpFilter(this.filterState, this.unfiltered, 'ips');

      const resultedModels = uniqBy(mostSpecificMatches, (model) => model.get('id'));

      this.models.replace(resultedModels);

      this.sort();
      return this.models;
    }

    return this.models;
  }

  /** will return array of selected subscription ids */
  get selectedSubscriptions() {
    return this.selectedArray.map((model) => model.get('id')) ?? [];
  }

  getSortValue = (field, model) => {
    const value = model.get(field);
    return value;
  };

  @action
  selectSubscriptions(subscriptionIds) {
    this.clearSelection();

    subscriptionIds.forEach((id) => {
      this.get(id)?.select({ multi: true });
    });

    this.applyPagination();
  }

  @action
  showAllAccounts() {
    this.removeDiscreteFilter(VIEW_DROPDOWN_DISCREET_FILTER_NAME);

    this.applyPagination();
  }

  @action
  showSelectedAccounts() {
    this.addDiscreteFilter({
      type: VIEW_DROPDOWN_DISCREET_FILTER_NAME,
      fn: (subscriptionModel) => subscriptionModel.isSelected
    });

    this.applyPagination();
  }

  @action
  addGroupFilter(subscriptionIds) {
    this.selectSubscriptions(subscriptionIds);
    this.addDiscreteFilter({
      type: 'group-dropdown',
      fn: (subscriptionModel) => subscriptionIds.includes(subscriptionModel.get('id'))
    });

    this.applyPagination();
  }

  @action
  removeGroupFilter() {
    this.removeDiscreteFilter('group-dropdown');

    this.applyPagination();
  }
}

export default SubscriptionFilterCollection;
